import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { PageLoader } from '../ui/PageLoader';

interface GuestRouteProps {
  children: React.ReactNode;
}

export function GuestRoute({ children }: GuestRouteProps) {
  const { isAuthenticated, initialized } = useAuth();

  if (!initialized) return <PageLoader />;
  if (isAuthenticated) return <Navigate to="/home" replace />;

  return <>{children}</>;
}
